import React, { useState, useEffect } from 'react'
import { Box, Tabs, Flex, Paper, FileInput, Group, Button, Text, TextInput, Image } from '@mantine/core'
import { IconArrowBigRight } from '@tabler/icons-react'
import { notificationError, notificationSuccess } from '../../../../ui/Notifications'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { updateOrderItemsImage } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { getOrderItems } from '../../../../../store/orderItems'

const FormAdustImageOrderProduct = ({ detailItem, onCloseModal }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [loadingForm, setLoadingForm] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [selectedMethodAdjustImage, setSelectedMethodAdjustImage] = useState('url')
  const [recentImage, setRecentImage] = useState(null)
  const [uploadImage, setUploadImage] = useState(null)
  const [updatedImage, setUpdatedImage] = useState('')

  const handleSetForm = (val) => {
    setItemId(val.id)
    setRecentImage(val.imageUrl)
  }
  
  useEffect(() => {
    if (detailItem) {
      handleSetForm(detailItem)
    }
    // eslint-disable-next-line
  }, [detailItem])

  const handleConvertToURL = async (val) => {
    const fileImage = val
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileImage)
    fileReader.onload = (reader) => {
      setUploadImage(fileImage)
      setUpdatedImage(reader.target.result)
    }
  }

  const submit = async () => {
    let payload
    
    if (selectedMethodAdjustImage === 'url') {
      payload = {
        image_url: updatedImage
      }
    }
    else {
      payload = new FormData();
      payload.append("image_literal", uploadImage)
    }

    try {
      setLoadingForm(true)
      const response = await updateOrderItemsImage(orderId, itemId, payload)
      if (response.success) {
        dispatch(getOrderDetail(orderId))
        dispatch(getOrderItems(orderId))
        notificationSuccess('Update Image Completed', 'You have been updated Order items Image')
        onCloseModal()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const loadForm = () => {
    return (
      <Box>
        <Tabs
          size='xs'
          my={4}
          variant="pills"
          radius="xl"
          value={selectedMethodAdjustImage}
          onChange={(val) => [setSelectedMethodAdjustImage(val), setUpdatedImage(''), setUploadImage(null)]}>
          <Tabs.List>
            <Tabs.Tab value="url">From URL</Tabs.Tab>
            <Tabs.Tab value="upload">From Local Computer</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="url">
            <Box my={12}>
              <TextInput
                name='image_url'
                value={updatedImage}
                onChange={(val) => setUpdatedImage(val.target.value)}
                withAsterisk
                size='xs'
              />
            </Box>
          </Tabs.Panel>
          <Tabs.Panel value="upload">
            <Box my={12}>
              <FileInput
                name='image_url'
                value={uploadImage}
                onChange={(val) => handleConvertToURL(val)}
                accept="image/jpeg,image/jpg,image/png"
                clearable
                withAsterisk
                size='xs'
              />
            </Box>
          </Tabs.Panel>
        </Tabs>
        <Box>
          <Text fz='md' fw='500'>Preview Image</Text>
          <Box my={20}>
            <Flex gap="xl" justify="center" align="center">
              <Paper shadow="sm" w={182} withBorder radius='md'>
                <Image w={180} h={180} radius='md' src={recentImage || NoImage} />
              </Paper>
              <IconArrowBigRight size={30} color='gray' />
              <Paper shadow="sm" w={182} withBorder radius='md'>
                <Image w={180} h={180} radius='md' src={updatedImage || NoImage} />
              </Paper>
            </Flex>
          </Box>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" disabled={updatedImage === ''} onClick={submit}>
                Update
              </Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }


  return (
    <Box>
      {loadForm()}
    </Box>
    
  )
}

export default FormAdustImageOrderProduct